export default __webpack_public_path__ + "static/media/cssorg.2990eb80.png";